import React from 'react';
import Icon from '../../../components/AppIcon';

const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Chandigarh', 'Puducherry', 'Jammu & Kashmir', 'Ladakh'
];

const CATEGORIES = [
  'Engineering', 'Management', 'Law', 'Medical', 'Arts & Science',
  'Architecture', 'Commerce', 'Education', 'Pharmacy', 'Agriculture',
  'Hospitality', 'Media'
];

const FEES_RANGES = [
  { label: 'Any', value: '' },
  { label: 'Under ₹1L/yr', value: '0-100000' },
  { label: '₹1L–₹3L/yr', value: '100000-300000' },
  { label: '₹3L–₹5L/yr', value: '300000-500000' },
  { label: '₹5L–₹10L/yr', value: '500000-1000000' },
  { label: 'Above ₹10L/yr', value: '1000000-' },
];

const SearchFilterBar = ({ filters, onChange, totalResults, loading }) => {
  const handleChange = (key, value) => {
    onChange?.({ ...filters, [key]: value, page: 1 });
  };

  const hasActiveFilters = filters?.state || filters?.category || filters?.feesRange || filters?.ranking === 'ranked' || filters?.search;

  const clearAll = () => {
    onChange?.({ search: '', state: '', category: '', feesRange: '', ranking: '', page: 1 });
  };

  return (
    <div className="bg-white rounded-xl shadow-md border border-border p-5 mb-8">
      {/* Search bar */}
      <div className="relative mb-4">
        <Icon name="Search" size={18} color="var(--color-muted-foreground)" className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        <input
          type="text"
          placeholder="Search institutes by name..."
          value={filters?.search || ''}
          onChange={(e) => handleChange('search', e?.target?.value)}
          className="w-full pl-10 pr-4 py-3 border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-colors"
        />
        {filters?.search && (
          <button
            onClick={() => handleChange('search', '')}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          >
            <Icon name="X" size={16} />
          </button>
        )}
      </div>
      {/* Filters row */}
      <div className="flex flex-wrap gap-3 items-center">
        {/* State filter */}
        <div className="flex items-center gap-2">
          <Icon name="MapPin" size={15} color="var(--color-muted-foreground)" />
          <select
            value={filters?.state || ''}
            onChange={(e) => handleChange('state', e?.target?.value)}
            className="text-sm border border-border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary bg-white min-w-[140px]"
          >
            <option value="">All States</option>
            {INDIAN_STATES?.map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        {/* Course/Category filter */}
        <div className="flex items-center gap-2">
          <Icon name="BookOpen" size={15} color="var(--color-muted-foreground)" />
          <select
            value={filters?.category || ''}
            onChange={(e) => handleChange('category', e?.target?.value)}
            className="text-sm border border-border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary bg-white min-w-[150px]"
          >
            <option value="">All Courses</option>
            {CATEGORIES?.map(c => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>

        {/* Fees range filter */}
        <div className="flex items-center gap-2">
          <Icon name="IndianRupee" size={15} color="var(--color-muted-foreground)" />
          <select
            value={filters?.feesRange || ''}
            onChange={(e) => handleChange('feesRange', e?.target?.value)}
            className="text-sm border border-border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary bg-white min-w-[150px]"
          >
            {FEES_RANGES?.map(f => (
              <option key={f?.value} value={f?.value}>{f?.label}</option>
            ))}
          </select>
        </div>

        {/* Ranking filter */}
        <div className="flex items-center gap-2">
          <Icon name="Award" size={15} color="var(--color-muted-foreground)" />
          <select
            value={filters?.ranking || ''}
            onChange={(e) => handleChange('ranking', e?.target?.value)}
            className="text-sm border border-border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary bg-white min-w-[140px]"
          >
            <option value="">Any Ranking</option>
            <option value="ranked">Ranked Institutes</option>
          </select>
        </div>

        {/* Results count + clear */}
        <div className="ml-auto flex items-center gap-3">
          {!loading && (
            <span className="text-sm text-muted-foreground">
              <span className="font-semibold text-foreground">{totalResults}</span> institutes found
            </span>
          )}
          {hasActiveFilters && (
            <button
              onClick={clearAll}
              className="flex items-center gap-1.5 text-sm text-primary hover:underline font-medium"
            >
              <Icon name="X" size={14} />
              Clear all
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchFilterBar;
